import { render, staticRenderFns } from "./SeaFreightPage.vue?vue&type=template&id=ade2a064&"
import script from "./SeaFreightPage.vue?vue&type=script&lang=js&"
export * from "./SeaFreightPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports